import React from 'react'
import './Navbar.css'

const Footer = () => {
  return (
    <div className='footer'>
        <div >
            <p><b>SUPPORT</b></p>
            <p>Online Help</p>
            <p>Customer Service</p>
            <p>Shipping FAQ</p>
            <p>Service Center</p>
            <p>Warrenty</p>
            <p>MI Exchange</p>
            <p>Bulk Orders</p>
            <p>User Guide</p>
            <p>Laptop Drivers</p>
            <p>MI Screen Product</p>
            <p>MI Complete Product</p>
        </div>
        <div>
            <p><b>SHOP AND LEARN</b></p>
            <p>Xiaomi 11T Pro 5G/Xiaomi</p>
            <p>11i Hypercharge 5G/Xiaomi</p>
            <p>11 Lite NE 5G</p>
            <p>MI 11X/MI 11X Pro</p>
            <p>Redmi Note 11 Pro Plus 5G</p>
            <p>Redmi Note 11 Pro</p>
            <p>Tv's And Laptops</p>
        </div>
        <div>
            <p><b>RETAIL STORE</b></p>
            <p>MI Home</p>
            <p>MI Authorized Store</p>
        </div>
        <div>
            <p><b>ABOUT US</b></p>
            <p>Xiaomi</p>
            <p>Privacy Policy</p>
            <p>User Agreement</p>
            <p>Integritry & Compliance</p>
            <p>Corporate Information</p>
            <p>Mediakit</p>
            <p>E-Waste Management</p>
            <p>In The Press</p>
            <p>Trust Center</p>
            <p>Culture</p>
            <p>TV Quality</p>
            <p>Service Quality</p>
        </div>
        <div>
            <p><b>CONTACT US</b></p>
            <p>Email</p>
            <p>Careers</p>
        </div>
    </div>
  )
}

export default Footer